export enum EventTopic {
  API_ERRORS = 'API_ERRORS',
}
